import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";
import HomePage from "./components/HomePage/Home";
import AboutPage from "./components/AboutPage/About";
import Navbar from "./components/Navbar/Navbar";
import RedLightGreenLightPage from "./components/Games/Vocabulary/RedLightGreenLightPage/RedLightGreenLightPage";
import StudyOptionsPage from "./components/StudyOptionsPage/StudyOptionsPage";

import GameOptionsPage from "./components/StudyOptionsPage/GameOptionsPage";

import HideAndSeekPage from "./components/Games/Listening/HideAndSeekPage/HideAndSeekPage";
import TutorialPage from "./components/Games/Listening/HideAndSeekPage/TutorialPage";
import TugOfWarPage from "./components/Games/Vocabulary/TugOfWarPage/TugOfWarPage";
import SugarHoneycombsPage from "./components/Games/Listening/SugarHoneycombsPage/SugarHoneycombsPage";
import MarblesPage from "./components/Games/Grammar/MarblesPage/MarblesPage";
import UnitsListPage from "./components/UnitsListPage/UnitsListPage";
import FlashcardStudyPage from "./components/FlashcardPage/FlashcardStudyPage";
import ProgressPage from "./components/ProgressPage/Progress";
import ChatboxPage from "./components/ChatboxPage/Chatbox";

import LoginPage from "./components/Authentication/LoginPage/Login";
import RegisterPage from "./components/Authentication/RegisterPage/Register";
import LogoutPage from "./components/Authentication/LogoutPage/Logout";
import ForgotPasswordPage from "./components/Authentication/ForgotPasswordPage/ForgotPassword";

import FeedbackPage from "./components/FeedbackPage/Feedback";
import MinglePage from "./components/Games/Grammar/MinglePage/MinglePage"
import TestPage from "./components/TestPage/Test";
import JegiPage from "./components/Games/Vocabulary/JegiPage/JegiPage";
import FlyingStonePage from "./components/Games/Grammar/FlyingStonePage/FlyStonePage";
import GongGiPage from "./components/Games/Listening/GongGiPage/GongGiPage";
import JumpRopePage from "./components/Games/Vocabulary/JumpRopePage/JumpRopePage";

import TextbookSelectionPage from "./components/TextbookSelectionPage/TextbookSelectionPage";

import {
  HOME_PATH,
  ABOUT_PATH,
  RED_LIGHT_GREEN_LIGHT_PATH,
  STUDY_OPTIONS_PATH,
  HIDE_AND_SEEK_TUTORIAL_PATH,
  TUG_OF_WAR_PATH,
  SUGAR_HONEYCOMBS,
  UNITS_LIST_PATH,
  FLASHCARD_STUDY_PATH,
  PROGRESS_PATH,
  CHATBOX_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  REGISTER_PATH,
  FORGOT_PASSWORD_PATH,
  MARBLES,
  FEEDBACK_PATH,
  MINGLE_PATH,
  TEST_PATH,
  JEGI_PATH,
  FLYING_STONE_PATH,
  GONG_GI_PATH,
  JUMP_ROPE_PATH,
  HIDE_AND_SEEK_PATH,
  PRACTICE_PATH,
  GAME_OPTIONS_PATH
} from "./constants";

import "./index.css";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        <Routes location={location}>
          <Route path={HOME_PATH} element={<HomePage />} />
          <Route path={ABOUT_PATH} element={<AboutPage />} />
          <Route path={PRACTICE_PATH} element={<TextbookSelectionPage />} />
          <Route path={UNITS_LIST_PATH} element={<UnitsListPage />} />
          <Route path={STUDY_OPTIONS_PATH} element={<StudyOptionsPage />} />

          <Route path={GAME_OPTIONS_PATH} element={<GameOptionsPage />} />

          <Route path={HIDE_AND_SEEK_PATH} element={<HideAndSeekPage />} />
          <Route path={HIDE_AND_SEEK_TUTORIAL_PATH} element={<TutorialPage />} />

          <Route path={RED_LIGHT_GREEN_LIGHT_PATH} element={<RedLightGreenLightPage />} />
          <Route path={TUG_OF_WAR_PATH} element={<TugOfWarPage />} />
          <Route path={SUGAR_HONEYCOMBS} element={<SugarHoneycombsPage />} />
          <Route path={MARBLES} element={<MarblesPage />} />
          <Route path={FLASHCARD_STUDY_PATH} element={<FlashcardStudyPage />} />
          <Route path={PROGRESS_PATH} element={<ProgressPage />} />
          <Route path={CHATBOX_PATH} element={<ChatboxPage />} />
          <Route path={LOGIN_PATH} element={<LoginPage />} />
          <Route path={LOGOUT_PATH} element={<LogoutPage />} />
          <Route path={REGISTER_PATH} element={<RegisterPage />} />
          <Route path={FORGOT_PASSWORD_PATH} element={<ForgotPasswordPage />} />
          <Route path={FEEDBACK_PATH} element={<FeedbackPage/>} />
          <Route path={MINGLE_PATH} element={<MinglePage/>} />
          <Route path={TEST_PATH} element={<TestPage />} />
          <Route path={JEGI_PATH} element={<JegiPage/>} />
          <Route path={FLYING_STONE_PATH} element={<FlyingStonePage/>} />
          <Route path={GONG_GI_PATH} element={<GongGiPage/>} />
          <Route path={JUMP_ROPE_PATH} element={<JumpRopePage/>} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Navbar />
    <AnimatedRoutes />
  </Router>
);
